// Function to populate hidden input fields from localStorage 
function getParentSelector() {
    return window.activeProForm ? document.getElementById(window.activeProForm) : document;
}

function populateInputs() {
    var parentSelector = getParentSelector();
    // console.log('in populate inputs');
    const inputs = parentSelector.querySelectorAll('#proForm input[type="hidden"][name]');

    inputs.forEach((input) => {
        const hiddenValue = input.getAttribute('data-value');
        // console.log('hiddenValue:', hiddenValue);

        const utmData = JSON.parse(localStorage.getItem('utmData'));
        // Get UTM parameters from URL
        const urlParams = new URLSearchParams(window.location.search);
        const utmParams = {
            utm_source: urlParams.get('utm_source'),
            utm_medium: urlParams.get('utm_medium'),
            utm_campaign: urlParams.get('utm_campaign'),
            utm_term: urlParams.get('utm_term'),
            utm_content: urlParams.get('utm_content'),
            utm_referlclick: urlParams.get('utm_referlclick'),
            utm_adgroup: urlParams.get('utm_adgroup'),
            utm_ad: urlParams.get('utm_ad'),
            utm_platform: urlParams.get('utm_platform')
        };
        if (hiddenValue && utmParams[hiddenValue]) {
            input.value = utmParams[hiddenValue];
            return; // if we found a UTM param matching the hiddenValue, we use it and skip the rest
        }

        // special handling for mc_current_page
        if (hiddenValue === 'mc_current_page') {
            // console.log('Setting mc_current_page to:', window.location.href);
            input.value = window.location.href;
            return; // skip the rest since we already set the value
        }

        // special handling for closet_type
        if (input.name === 'closet_type') {
            input.value = hiddenValue;
            return; // skip the rest since we already set the value
        }

        // Special handling for landing_page
        if (hiddenValue === 'landing_page') {
            try {
                if (utmData?.referrer) {
                    input.value = utmData.referrer;
                    return; // skip the rest since we already set the value
                }
            } catch (e) {
                console.warn('Failed to parse utmData from localStorage:', e);
            }
        }

        // special handling for mc_engaged_user
        else if (hiddenValue === 'mc_engaged_user') {
            // console.log('Setting mc_engaged_user from cookie:', getCookie('mc_engaged_user'));
            input.value = getCookie('mc_engaged_user') || '';
            return; // skip the rest since we already set the value
        }

        // Special handling for device
        else if (hiddenValue === 'device') {

            const isMobile = /Mobi|Android/i.test(navigator.userAgent);
            input.value = isMobile ? 'mobile' : 'desktop';
            return; // skip the rest since we already set the value
        }

        // Special handling for ab_tests
        else if (hiddenValue === 'ab_tests') {
            try {
                // 1. READ FROM LOCALSTORAGE HISTORY INSTEAD OF WINDOW.INTELLIGEMS
                const stored = localStorage.getItem('ig_historical_experiments');
                const experiments = stored ? JSON.parse(stored) : [];

                if (!experiments.length) {
                    console.warn('[Form Populate] No historical experiments found in localStorage');
                    input.value = ''; // set to empty string if no experiments found
                    return;
                }

                // 2. Loop through the combined, persistent experiments we saved earlier
                let abtData = '';
                experiments.forEach((experiment) => {
                    try {
                        const expName = experiment.name || 'Unknown Experiment';
                        const vName = experiment.variant || 'unknown';
                        abtData += `${expName} : ${vName}; `;
                    } catch (err) {
                        console.error('Error processing experiment from storage:', err);
                    }
                });

                console.log('[Form Populate] Successfully injected into hidden field:', abtData.trim());
                input.value = abtData.trim();
            } catch (error) {
                console.error('Error retrieving Intelligems experiments from storage:', error);
            }
        }

        // Otherwise, use localStorage value
        else {
            const stored = utmData ? utmData[hiddenValue] : null;
            if (stored !== null && stored !== undefined) {
                input.value = stored;
                return; // if we found a value in utmData matching the hiddenValue, we use it and skip the rest
            }
            else {
                const stored = localStorage.getItem(hiddenValue);
                if (stored !== null) {
                    try {
                        input.value = JSON.parse(stored); // if stored as JSON
                        return; // if we successfully parsed the value, we can skip the rest
                    } catch {
                        input.value = stored; // fallback to raw string
                        return; // we set the value, we can exit now
                    }
                }
            }
        }
    });
}

// Poll for dynamically inserted input elements
const interval = setInterval(() => {
    var parentSelector = getParentSelector();
    if (parentSelector.querySelector('input[name]')) {
        populateInputs();
        clearInterval(interval);
    }
}, 100);

// Stop polling after 5 seconds
setTimeout(() => clearInterval(interval), 5000);

// When submit form...
function formSubmitted(formEl) {
    const container = formEl.closest('.pro-form'); // the correct wrapper for THIS form

    // if recaptcha exists, run it first
    if (container && container.querySelector('#recaptcha-score') != null) {
        const submitBtn = container.querySelector('.form-submit');
        if (submitBtn) submitBtn.style.display = 'none';

        // assumes getRecaptchaAndSubmit calls the callback after score is ready
        getRecaptchaAndSubmit(() => submitProForm(formEl));
    } else {
        submitProForm(formEl);
    }

    return false; // prevent normal navigation
}

function submitProForm(formEl) {
    const container = formEl.closest('.pro-form') || document;

    const heading = container.querySelector('.form-heading');
    const subheading = container.querySelector('.form-subheading');

    // hide
    formEl.style.display = 'none';
    if (heading) heading.style.display = 'none';
    if (subheading) subheading.style.display = 'none';

    // message
    const msg = document.createElement('p');
    msg.className = 'form-thank-you';
    msg.innerHTML =
        'Thank you! Your form has been submitted successfully.<br>One of our reps will be in touch with you shortly.';
    (container.classList && container.classList.contains('pro-form') ? container : formEl.parentElement).appendChild(msg);

    // submit to hidden iframe
    formEl.submit();
}


function closeProForm() {
    document.querySelectorAll('.pro-form').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.proFormModalOverlay').forEach(el => el.style.display = 'none');
}

function modalOverlayClick(me, event) {
    var parentSelector = getParentSelector();
    const form = window.activeProForm ? parentSelector : parentSelector.querySelector('.pro-form');

    // Check if the click is outside the popup (i.e., not inside .pro-form)
    if (!form.contains(event.target)) {
        document.querySelectorAll('.pro-form').forEach(el => el.style.display = 'none');
        document.querySelectorAll('.proFormModalOverlay').forEach(el => el.style.display = 'none');
    }
}
